export default {"src":"/_next/static/media/google-pay-mark.766896f3.svg","height":400,"width":753,"blurWidth":0,"blurHeight":0};